<!--
Layout vertical (estilo MercadoLibre):
- Imagem grande no topo do card (aspect-ratio fixo, centralizada)
- Sobre a imagem: quantidade no carrinho, selos de destaque e botao de acao
- Abaixo: nome (ate 2 linhas com ellipsis) e preco em destaque
- Rodape discreto: codigo do item + botao de compartilhar
-->
<div class="card product fade-in"
     role="button"
     tabindex="0"
     [attr.aria-label]="produto.nome"
     (click)="onAbrirDetalhe()"
     (keydown.enter)="onAbrirDetalhe()"
     (keydown.space)="$event.preventDefault(); onAbrirDetalhe()">
  <!-- Imagem no topo -->
  <div class="media">
    <img *ngIf="temImagem && !imagemComErro"
         class="media-img"
         [src]="urlImagem"
         [alt]="produto.nome"
         loading="lazy"
         (error)="imagemComErro = true" />
    <div *ngIf="!temImagem || imagemComErro" class="media-img media-placeholder">
      <i class="pi pi-image"></i>
    </div>
    <span
      *ngIf="quantidadeNoCarrinho > 0"
      class="qty-badge"
      [class.pop]="badgePulsando"
      (animationend)="badgePulsando = false"
      aria-label="Quantidade no carrinho">
      {{ quantidadeNoCarrinho }}
    </span>

    <!-- Selos de destaque (canto superior esquerdo, empilhados): promocao, novidade e desconto -->
    <div class="badges" *ngIf="ehNovidade || emPromocao || percentualDesconto">
      <span *ngIf="emPromocao" class="badge badge-icone badge-promocao"
            [attr.aria-label]="'cardapio_digital.badge_promocao' | translate">
        <i class="fas fa-tag"></i>
        <span class="badge-texto">{{ 'cardapio_digital.badge_promocao' | translate }}</span>
      </span>
      <span *ngIf="ehNovidade" class="badge badge-icone badge-novidade"
            [attr.aria-label]="'cardapio_digital.badge_novidade' | translate">
        <i class="pi pi-star-fill"></i>
        <span class="badge-texto">{{ 'cardapio_digital.badge_novidade' | translate }}</span>
      </span>
      <span *ngIf="percentualDesconto" class="badge discount-badge">
        -{{ percentualDesconto }}%
      </span>
    </div>

    <!--
    Botao de acao no canto inferior direito da imagem. O icone diz o que vai
    acontecer, para nao enganar o cliente:
      "+"     -> adiciona 1 unidade ao carrinho;
      sliders -> exige escolha (variante / grupo obrigatorio), abre o detalhe.
    Some sem saldo em estoque. O stopPropagation (clique e teclado) impede que a
    acao do card inteiro dispare junto.
    -->
    <button
      *ngIf="mostraBotaoAcao"
      type="button"
      class="quick-add-btn"
      [class.quick-add-btn--configurar]="exigeConfiguracao"
      (click)="onAcaoRapida($event)"
      (keydown.enter)="$event.stopPropagation()"
      (keydown.space)="$event.stopPropagation()"
      [attr.aria-label]="(exigeConfiguracao ? 'cardapio_digital.escolher_opcoes' : 'cardapio_digital.adicionar_rapido') | translate"
      [title]="(exigeConfiguracao ? 'cardapio_digital.escolher_opcoes' : 'cardapio_digital.adicionar_rapido') | translate">
      <i class="pi" [ngClass]="exigeConfiguracao ? 'pi-sliders-h' : 'pi-plus'"></i>
    </button>
  </div>

  <!-- Conteudo -->
  <div class="info">
    <div class="title" [title]="produto.nome">{{ produto.nome }}</div>

    <div class="price">
      <span *ngIf="precoPromocionalFormatado" class="price-original">
        {{ precoFormatado }}
      </span>
      <span class="price-current">{{ precoPromocionalFormatado || precoFormatado }}</span>
    </div>
  </div>

  <!-- Rodape discreto -->
  <div class="footer">
    <span class="id">#{{ id4(produto.id) }}</span>
    <button
      type="button"
      class="share-btn"
      (click)="onCompartilhar($event)"
      (keydown.enter)="$event.stopPropagation()"
      (keydown.space)="$event.stopPropagation()"
      [attr.aria-label]="'cardapio_digital.compartilhar' | translate"
      [title]="'cardapio_digital.compartilhar' | translate">
      <i class="pi pi-share-alt"></i>
    </button>
  </div>
</div>
